export default {
    setAllowedExtensions(state, extensions) {
      state.allowedExtensions = extensions;
    },
    setMaxFileSize(state, size) {
      state.maxFileSize = size;
    },
    setFileSizeType(state, sizetype) {
      state.fileSizeType = sizetype;
    },
    setMaxFileCount(state, count) {
      state.maxFileCount = count;
    },
    setSelectedFiles(state, files) {
      state.selectedFiles = files;
    },
    setError(state, errorMsg) {
      state.error = errorMsg;
    },
    setIsSuccessful(state, isSuccessful) {
      state.isSuccessful = isSuccessful;
    }
  }